import { Component, inject, OnInit } from "@angular/core";
import { MatTooltip } from "@angular/material/tooltip";
import { AccountSelectionService } from "@front/m19-services";
import { ISelectComponent, MarketplaceFlagComponent, Option } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { AccountGroupSelectorComponent } from "@m19-board/account-group-selector/account-group-selector.component";
import { ICON_WARNING_TRIANGLE } from "@m19-board/utils/iconsLabels";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { DASHBOARD_TYPE } from "@front/m19-injection-token";
import { AccountGroup } from "@front/m19-models";
import { Marketplace } from "@front/m19-api-client";

@UntilDestroy()
@Component({
  selector: "app-account-selector",
  templateUrl: "./account-selector.component.html",
  styleUrls: ["./account-selector.component.scss"],
  standalone: true,
  imports: [ISelectComponent, TranslocoDirective, MatTooltip, AccountGroupSelectorComponent, MarketplaceFlagComponent],
})
export class AccountSelectorComponent implements OnInit {
  scope = inject(DASHBOARD_TYPE);

  readonly ICON_WARNING_TRIANGLE = ICON_WARNING_TRIANGLE;

  constructor(private accountSelectionService: AccountSelectionService) {}

  isReadOnly = false;

  selectedAccountGroup = this.accountSelectionService.selectedAccountGroup;
  selectedMarketplacesMap = this.accountSelectionService.selectedMarketplacesMap;
  selectedMarketplace = this.accountSelectionService.selectedMarketplace;
  marketplaceOptions = this.accountSelectionService.marketplaceOptions;

  ngOnInit(): void {
    this.accountSelectionService.readOnlyMode$.pipe(untilDestroyed(this)).subscribe((b) => (this.isReadOnly = b));
  }

  selectGroup(accountGroup?: AccountGroup) {
    if (!accountGroup) return;

    const newAccountWithSameMarketplace = accountGroup
      .getAccountMarketplaces()
      .find((am) => am.marketplace === this.selectedMarketplace());
    const newAccount = newAccountWithSameMarketplace ?? accountGroup.getAccountMarketplaces()[0];

    this.accountSelectionService.updateAccountInUrl(
      newAccount.accountId,
      newAccount.marketplace,
      accountGroup?.organizationId,
    );
  }

  selectMarketplace(option: Option<Marketplace>) {
    this.accountSelectionService.updateAccountInUrl(undefined, option.value, undefined);
  }
}
